import constants from '../../helpers/constants';
import store from '../../store/main';

export const NOTIFICATION_POPUP_TYPE = {
  NEWS: 'news',
  DEMO: 'demo',
  DEMO_SIDEBAR: 'demo_sidebar',
  SUPPORT_HINT: 'support_hint',
};

export const NOTIFICATION_POPUP_CONFIG = {
  [NOTIFICATION_POPUP_TYPE.NEWS]: {
    content: null,
    title: __('news_notify_popup_title'),
    imageSrc: 'https://cdn.ganttpro.com/app/imgs/notifications/newsNotifyIcon.svg',
    imgContainerBg: '#FF9A00',
    positionContext: null,
    controlNodeId: 'footerBtnLearningCenterId',
    attachedToRefName: 'learningCenter',
    onCloseClickHandler: () => {
      const { lastNewsEntryId } = window.user;

      if (lastNewsEntryId) {
        store.dispatch(
          'user/updateActivityStatus',
          { activityName: constants.USER_ACTIVITIES.LAST_NEWS_ID, status: lastNewsEntryId },
        );
      }
    },
  },
  [NOTIFICATION_POPUP_TYPE.DEMO]: {
    content: __('demo_modal_popup_text'),
    title: __('demo_modal_popup_title'),
    imageSrc: 'https://cdn.ganttpro.com/statics/media/images/email/tania.png',
    isRoundedImg: true,
    positionContext: null,
    controlNodeId: 'footerBtnDemoId',
    attachedToRefName: 'demo',
    onCloseClickHandler: () => {
      const demoPopupActivityStatus = store.getters['user/getActivityStatus'](constants.USER_ACTIVITIES.DEMO_POPUP);
      const secondDemoPopupActivityStatus = store.getters['user/getActivityStatus'](constants.USER_ACTIVITIES.SECOND_DEMO_POPUP);

      if (!demoPopupActivityStatus) {
        store.dispatch(
          'user/updateActivityStatus',
          { activityName: constants.USER_ACTIVITIES.DEMO_POPUP, status: 1 },
        );
      }
      if (demoPopupActivityStatus && !secondDemoPopupActivityStatus) {
        store.dispatch(
          'user/updateActivityStatus',
          { activityName: constants.USER_ACTIVITIES.SECOND_DEMO_POPUP, status: 1 },
        );
      }
    },
  },
  [NOTIFICATION_POPUP_TYPE.DEMO_SIDEBAR]: {
    type: NOTIFICATION_POPUP_TYPE.DEMO_SIDEBAR,
    content: __('demo_modal_popup_text'),
    title: __('demo_modal_popup_title'),
    imageSrc: 'https://cdn.ganttpro.com/statics/media/images/email/tania.png',
    isRoundedImg: true,
    imgContainerBg: '#FFF5E5',
    positionContext: null,
    controlNodeId: 'js-sidebar-menu-item-help',
    attachedToRefName: 'help',
    onCloseClickHandler: () => {
      const demoPopupActivityStatus = store.getters['user/getActivityStatus'](constants.USER_ACTIVITIES.DEMO_POPUP);
      const secondDemoPopupActivityStatus = store.getters['user/getActivityStatus'](constants.USER_ACTIVITIES.SECOND_DEMO_POPUP);

      if (!demoPopupActivityStatus) {
        store.dispatch(
          'user/updateActivityStatus',
          { activityName: constants.USER_ACTIVITIES.DEMO_POPUP, status: 1 },
        );
      }
      if (demoPopupActivityStatus && !secondDemoPopupActivityStatus) {
        store.dispatch(
          'user/updateActivityStatus',
          { activityName: constants.USER_ACTIVITIES.SECOND_DEMO_POPUP, status: 1 },
        );
      }
    },
  },
  [NOTIFICATION_POPUP_TYPE.SUPPORT_HINT]: {
    type: NOTIFICATION_POPUP_TYPE.SUPPORT_HINT,
    content: __('lc_support_hint_text'),
    title: __('lc_support_hint_title'),
    imageSrc: '',
    imgContainerBg: '#FFF5E5',
    positionContext: null,
    controlNodeId: 'js-sidebar-menu-item-help',
    attachedToRefName: 'help',
    onCloseClickHandler: () => {},
  },
};
